import {Box, Stack, Tooltip, Typography} from "@mui/material";
import useCountdown from "../hooks/useCountdown";
import dayjs from "dayjs";

export interface IDraftTimerProps {
    targetDate: dayjs.Dayjs | null;
    onExpired?: () => void;
    description: string;
}

const DraftTimer = (props: IDraftTimerProps) => {
    const countdown = useCountdown({
        targetDate: props.targetDate,
        onExpired: () => {
            props.onExpired?.();
        }
    });

    return (
        <Box
            position="fixed"
            top={56}
            right={16}
            boxShadow="0px 10px 40px rgba(0, 104, 150, 0.2)"
            bgcolor="white"
            borderRadius={2}
            zIndex={5000}
            py={1}
            px={2}
        >
            <Stack direction="row" alignItems="center" columnGap={3}>
                <Tooltip title={props.description}>
                    <Typography variant={"body"}>
                        {`${String(countdown.hours).padStart(2, '0')}:${String(countdown.minutes).padStart(2, '0')}:${String(countdown.seconds).padStart(2, '0')}`}
                    </Typography>
                </Tooltip>

            </Stack>
        </Box>
    );
};

export default DraftTimer;